import React from "react";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => {
  const text = `Hi Turahtid! I have a question about sizing: ${window.location.href}`;
  const href = `https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="group fixed bottom-24 sm:bottom-5 right-4 sm:right-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] text-black shadow-lg shadow-black/40 h-14 pl-4 pr-4 hover:pr-5 transition-[padding,transform] duration-200 hover:-translate-y-0.5"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline font-bold uppercase tracking-widest text-xs">Size help?</span>
    </a>
  );
};
